import api from "../api/axios";

const adminService = {
  // Sistemdeki tüm kullanıcılar
  getAllUsers: (searchTerm) => {
    let url = "admin/users";
    if (searchTerm) url += `?SearchTerm=${searchTerm}`;
    return api.get(url);
  },

  // Kullanıcı aktif/pasif yap
  toggleUserActive: (id) => api.post("admin/toggle-user-active", { id }),

  // Kullanıcı şifre değiştir
  changeUserPassword: (id, newPassword) => api.post("admin/change-user-password", { id, newPassword }),
};

export default adminService;
